/**
 * Internal dependencies
 */
import {
    CURRENT_KIOSK_RECEIVE,
    CURRENT_KIOSK_REQUEST,
    CURRENT_KIOSK_REQUEST_SUCCESS,
    CURRENT_KIOSK_REQUEST_FAILURE,
} from 'state/action-types';

import cscom from 'lib/customer-site-api';
import {getCurrentKiosk, requestingCurrentKiosk} from 'state/current-kiosk/selectors';

/**
 * [description]
 *
 * @param  {[type]}         [description]
 * @return {[type]}         [description]
 */
export const setCurrentKiosk = (kioskplan) => {
    return {
        type: CURRENT_KIOSK_RECEIVE,
    };
};

/**
 * [description]
 *
 * @param  {[type]} ) [description]
 * @return {[type]}   [description]
 */
export const requestCurrentKiosk = () => (dispatch) => {
    dispatch({
        type: CURRENT_KIOSK_REQUEST,
    });

    return cscom
        .kioskPlan()
        .get()
        .then((kioskplan) => {
            dispatch({
                type: CURRENT_KIOSK_REQUEST_SUCCESS,
            });
            dispatch({
                type: CURRENT_KIOSK_RECEIVE,
                payload: {
                    kioskplan,
                },
            });

            return kioskplan;
        })
        .catch((error) => {
            if (error == 'Error: Not Found') {
                dispatch({
                    type: CURRENT_KIOSK_REQUEST_SUCCESS,
                });
                return;
            }
            dispatch({
                type: CURRENT_KIOSK_REQUEST_FAILURE,
                error,
            });
        });
};

/**
 * [description]
 * 
 * @param  {...[type]} props) [description]
 * @return {[type]}           [description]
 */
export const requestCurrentKioskIfNotRequested = (...props) => async (dispatch, getState) => {
    
    const currentKiosk = getCurrentKiosk(getState());
    const requesting = requestingCurrentKiosk(getState());

    if (!currentKiosk && requesting == false) {
        return dispatch(requestCurrentKiosk(...props));
    }

    return currentKiosk;
}
